import "./Popup.css"

const Popup = ({ isOpen, onClose, children, title, hideCloseButton = false, footer = null, disableClose = false }) => {
  if (!isOpen) return null;

  return (
    <div>
      
        <div className="popup-overlay">
            <div className="popup-content">
              <div className="popup-header">
                {title && <h2 className="popup-title">{title}</h2>}
                {!hideCloseButton && (
                  <span
                    className={`popup-close-btn${disableClose ? " disabled" : ""}`}
                    onClick={disableClose ? undefined : onClose}
                    aria-disabled={disableClose}
                  >X</span>
                )}
              </div>
              <div className="popup-body">
                {children}
              </div>
              {footer && <div className="popup-footer">{footer}</div>}
           </div>
       </div>
   </div>
   
  );
}


export default Popup;

